"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileSearchBoldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var FileSearchBold = function FileSearchBold(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M12 0a12 12 0 1012 12A12 12 0 0012 0zm-.6 19.71a.58.58 0 01-.85 0l-1.5-1.56a.14.14 0 00-.18 0 3.22 3.22 0 01-4.35-.75 3.55 3.55 0 01.24-4.59 3.21 3.21 0 014.41-.25 3.55 3.55 0 01.71 4.54.15.15 0 000 .19l1.5 1.56a.65.65 0 01.02.86zm-.4-9.49A.63.63 0 0111 9h4.19a.63.63 0 010 1.25zm3.29 2.18a.61.61 0 01-.6.63H11.3a.63.63 0 010-1.25h2.39a.61.61 0 01.6.62zm3.9 4.06A1.23 1.23 0 0117 17.71h-5.73a.21.21 0 01-.16-.08l-.22-.23a.28.28 0 010-.25 4.07 4.07 0 00.22-.58.16.16 0 01.14-.11h5.47a.3.3 0 00.3-.31V7.79a.31.31 0 00-.09-.22l-1.3-1.32a.27.27 0 00-.21-.09H8.9a.3.3 0 00-.3.31v4.45a.17.17 0 01-.06.12.14.14 0 01-.14 0 3.65 3.65 0 00-.87-.19.16.16 0 01-.13-.15V6.16a1.23 1.23 0 011.2-1.25h6.94a1.18 1.18 0 01.85.36l1.45 1.51a1.31 1.31 0 01.35.89z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M7.9 13.21a2 2 0 00-2.28.48 2.26 2.26 0 00-.46 2.38 2.1 2.1 0 001.94 1.35 2.15 2.15 0 002.1-2.19 2.19 2.19 0 00-1.3-2.02z"
  }));
};
FileSearchBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const FileSearchBoldIcon = exports.FileSearchBoldIcon = (0, _createIconComponent.default)(FileSearchBold, 'FileSearchBold');